import { RisultatiQuestionari } from "./RisultatiQuestionari";

export class ResponseRisultatiQuestionari {
    secondoAnno!: Array<RisultatiQuestionari>;
    terzoAnno!: Array<RisultatiQuestionari>;
}
